import React from 'react';
import PropTypes from 'prop-types';

import { system as styledSystem } from '@styled-system/core';

const styledParser = styledSystem({
  display: true,
  marginTop: true,
  marginBottom: true,
  opacity: true,
  backgroundColor: true,
});

const SrSeparator = ({ ..._styles }) => {
  const style = styledParser(_styles);
  return <div style={style} className="SrSeparator" />;
};

const inlineStyleProp = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

SrSeparator.propTypes = {
  display: inlineStyleProp,
  marginTop: inlineStyleProp,
  marginBottom: inlineStyleProp,
};

SrSeparator.displayName = 'SrSeparator';

export default SrSeparator;
